module.exports = __webpack_public_path__ + "static/media/main.0e8022ec.gif";